import { ShieldOff } from 'lucide-react';

export interface BlindedNoticeProps {
  roleMasterRef?: string | null;
  /** Short label for what's hidden, e.g. "Documents", "Forms", "Subjects". */
  contentLabel?: string;
  /** Compact variant for use inside table cells / tight panels. */
  compact?: boolean;
}

export function BlindedNotice({
  roleMasterRef,
  contentLabel,
  compact = false,
}: BlindedNoticeProps) {
  const title = compact
    ? 'Content hidden'
    : `${contentLabel ?? 'Content'} hidden — you're blinded on this study`;

  return (
    <div
      className={
        compact
          ? 'flex items-center gap-2 rounded border border-warning-200 bg-warning-50 px-3 py-2 text-xs text-warning-800'
          : 'flex flex-col items-center gap-2 rounded-lg border border-warning-200 bg-warning-50 p-8 text-center text-sm text-warning-800'
      }
    >
      <ShieldOff className={compact ? 'h-4 w-4 shrink-0 text-warning-700' : 'h-6 w-6 text-warning-700'} />
      <div className="font-medium text-ink-primary">{title}</div>
      {!compact && (
        <div className="max-w-md text-warning-800">
          {contentLabel ? `${contentLabel} are ` : 'Content is '}
          hidden from you because you have a blinded assignment on this study
          {roleMasterRef ? ` (${roleMasterRef})` : ''}. If you need access, contact
          the study administrator to review your blinding assignment.
        </div>
      )}
    </div>
  );
}
